// Single decision point for the AP (CxP) rollout (T21): resolves the reworked invoices
// view when the society has HAS_NEW_AP_VIEW, else the current one. Default is the
// OLD view (flag false when the permission is absent). Neither view reads the flag.
//
// This is used directly as the `component` of the `invoices` route record (instead of
// a dispatcher component rendered via `<component :is>`) so that the resolved component
// IS the one Vue Router registers for the route. That matters because Vue Router only
// invokes in-component navigation guards (e.g. `beforeRouteLeave`) for the component
// registered in the route record — a component mounted via `<component :is>` inside a
// wrapper is invisible to the router and its guards never fire. `Documents.vue` relies
// on its own `beforeRouteLeave` to persist filters (tab/page/search), so it must be the
// component the router actually sees.
//
// ACCEPTED TRADEOFF: Vue Router caches the resolved component per route record after the
// first resolution, so toggling HAS_NEW_AP_VIEW for a society requires a page reload to
// switch which view renders — it will not swap reactively mid-session.
import { checkFeatureFlag, FEATURES } from '@/features'

export function resolveInvoicesView() {
  return checkFeatureFlag(FEATURES.NEW_AP_VIEW)
    ? import('@/views/payments/rework/InvoicesReworkView.vue')
    : import('@/views/payments/Documents.vue')
}
